import pc from '../src/components/pc/locales/en-US';
import mobile from '../src/components/mobile/locales/en-US';
export default {
    pc,
    mobile
};
